import React from 'react';
import { BrandButton } from '../ui/BrandButton';
import { ImagePlaceholder } from '../ui/ImagePlaceholder';
import { ScrollReveal } from '../ui/ScrollReveal';
export function HeroSection() {
  return <section className="relative w-full min-h-[80vh] flex flex-col pt-24 md:pt-32 pb-16 overflow-hidden bg-gradient-to-b from-[#F8C8DC] to-[#FFF8F0]" data-id="element-60">
      <div className="container mx-auto px-4 md:px-8 flex-grow flex flex-col md:flex-row items-center justify-center gap-12 md:gap-8" data-id="element-61">
        {/* Text Content */}
        <div className="w-full md:w-1/2 flex flex-col items-center md:items-start text-center md:text-left z-10" data-id="element-62">
          <ScrollReveal direction="up" delay={100} data-id="element-63">
            <h1 className="font-heading text-5xl md:text-7xl lg:text-8xl font-bold text-[#2D1A1A] leading-tight mb-4" data-id="element-64">
              Stack Your <br className="hidden md:block" data-id="element-65" />
              <span className="text-[#E91E8C]" data-id="element-66">Story</span>
            </h1>
          </ScrollReveal>

          <ScrollReveal direction="up" delay={300} data-id="element-67">
            <p className="font-script text-3xl md:text-4xl text-[#6B1D4A] mb-10 transform -rotate-2" data-id="element-68">
              Buttery smooth layers, designed to stack your way
            </p>
          </ScrollReveal>

          <ScrollReveal direction="up" delay={500} data-id="element-69">
            <div className="flex flex-col sm:flex-row gap-4 w-full sm:w-auto" data-id="element-70">
              <BrandButton href="/collections" variant="primary" data-id="element-71">
                Shop Collections
              </BrandButton>
              <BrandButton href="https://shop.butter-blonde.com" external variant="outline" data-id="element-72">
                Build Your Stack
              </BrandButton>
            </div>
          </ScrollReveal>
        </div>

        {/* Hero Image */}
        <div className="w-full md:w-1/2 z-10" data-id="element-73">
          <ScrollReveal direction="left" delay={400} data-id="element-74">
            <div className="relative" data-id="element-75">
              <div className="absolute -inset-4 bg-[#F5D76E] rounded-full opacity-20 blur-2xl" data-id="element-76"></div>
              <ImagePlaceholder label="Lifestyle shot — layered necklaces on skin" aspectRatio="portrait" className="md:aspect-[4/5] shadow-2xl rotate-2 hover:rotate-0 transition-transform duration-500" data-id="element-77" />
            </div>
          </ScrollReveal>
        </div>
      </div>

      {/* Decorative background elements */}
      <div className="absolute top-20 right-10 w-64 h-64 bg-[#FFF8F0] rounded-full mix-blend-overlay filter blur-3xl opacity-50 animate-pulse" data-id="element-78"></div>
      <div className="absolute bottom-20 left-10 w-72 h-72 bg-[#E91E8C] rounded-full mix-blend-overlay filter blur-3xl opacity-20" data-id="element-79"></div>
    </section>;
}